import { render } from "./AppRouter.vue?vue&type=template&id=cd856076"
import script from "./AppRouter.vue?vue&type=script&lang=js"
export * from "./AppRouter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__